import { fetchAndParse, jsonHeaders } from '#lib/helpers/fetch.js';
import { useAuthMutation } from '#lib/hooks/use-mutation.js';

async function updateCheck(model, authHeaders) {
    return await fetchAndParse(`${API_URL}/p/search/check`, {
        method: 'PUT',
        headers: { ...authHeaders, ...jsonHeaders },
        body: JSON.stringify(model)
    });
}

export default function useSearchCheck() {
    return useAuthMutation({
        mutationFn: updateCheck
    })
}